import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import PreviewCard from './PreviewCard';
import CardDeck from './CardDeck';
import { spycraftMixedArrType } from '../proptypes/spycraft';
import { ssColorBlue } from '../constants/style-constants';

const SpycraftCardDeck = ({
  cardsPerRow, content, highlight, showDescription,
}) => (
  <CardDeck cardsPerRow={cardsPerRow}>
    {
      content.map(props => (
        <PreviewCard
          // eslint-disable-next-line react/prop-types
          key={props.id}
          {...props}
          css={css`
            ${(highlight ? `background-color: ${ssColorBlue};` : '')}`}
          showDescription={showDescription}
        />
      ))
    }
  </CardDeck>
);

SpycraftCardDeck.defaultProps = {
  cardsPerRow: 2,
  highlight: false,
  showDescription: true,
};

SpycraftCardDeck.propTypes = {
  cardsPerRow: PropTypes.number,
  highlight: PropTypes.bool,
  showDescription: PropTypes.bool,
  content: spycraftMixedArrType.isRequired,
};

export default SpycraftCardDeck;
